import React, { FC } from "react"
import styled from "styled-components"
import colors from "../utils/colors"
import { breakpoints as bp } from "./layout"
import Icon from "./Icon"
interface CurrencySelectorElementProps {
  currencyHeading: string
  currencyName: string
  currencySymbol: string
  classNames?: string
  ifShowCheckIcon: boolean
  onClick: () => void
}
const CurrencySelectorElementContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-bottom: 24px;
  text-align: left;
  :hover {
    cursor: pointer;
  }
`
const LineSeparator = styled.div`
  display: block;
  width: auto;
  height: 0.8rem;
  border-left: 1px solid ${colors.gray60};
  margin: auto 8px;
`

const CurrencyElementHeader = styled.div`
  display: flex;
  justify-content: space-between;
  @media (min-width: ${bp.tabletMin}) {
    width: 80%;
  }
  p {
    margin-top: 0;
    margin-bottom: 8px;
    width: auto;
    font-size: 18px;
  }
  svg {
    width: auto;
    color: ${colors.teal};
  }
  span {
    font-size: 14px;
    color: ${colors.gray60};
    width: 100%;
  }
`
const CurrencyDetails = styled.div`
  display: flex;
  font-size: 14px;
  color: ${colors.gray60};
`

const CurrencySelectorElement: FC<CurrencySelectorElementProps> = props => {
  const {
    currencyHeading,
    currencyName,
    currencySymbol,
    classNames,
    ifShowCheckIcon,
    onClick,
  } = props
  return (
    <CurrencySelectorElementContainer className={classNames} onClick={onClick}>
      <CurrencyElementHeader>
        <p>{currencyHeading}</p>
        {ifShowCheckIcon && <Icon icon="check" width="18px" height="18px" />}
      </CurrencyElementHeader>
      <CurrencyDetails>
        <span>{currencyName}</span>
        <LineSeparator />
        <span>{currencySymbol}</span>
      </CurrencyDetails>
    </CurrencySelectorElementContainer>
  )
}

export default CurrencySelectorElement
